// extracted by mini-css-extract-plugin
export var richtext = "sectionHtml-module--richtext--e75df";
export var section = "sectionHtml-module--section--09774";